/* eslint-disable tailwindcss/no-arbitrary-value */
import Section from 'molecules/Section';

import ResourceCard from 'components/Cards/ResourceCard';
import Pagination from 'components/Resources/Pagination';
import Sidebar from 'components/Resources/Sidebar';

import type { ContentfulTaxonomyTag } from 'graphqlTypes';
import type { SectionProps } from 'molecules/Section';
import type { FC } from 'react';
import type { PostUnion } from 'types';

interface PostListingProps extends SectionProps {
  activeTag?: ContentfulTaxonomyTag;
  authorSlug?: string;
  contentful_id?: string;
  styles?: string;
  currentPageNumber: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  posts: PostUnion[];
  resourceType: string;
  tags: ContentfulTaxonomyTag[];
  totalPages: number;
}

const PostListing: FC<PostListingProps> = ({
  activeTag,
  authorSlug,
  contentful_id,
  styles,
  currentPageNumber,
  hasNextPage,
  posts,
  resourceType,
  tags,
  totalPages,
  postHeading,
}) => {
  const generateUrl = () => {
    if (authorSlug) {
      return `/author/${authorSlug}`;
    }

    if (activeTag) {
      return `/${resourceType}/${activeTag?.name?.toLowerCase()?.replace(/\s+/g, '-')}`;
    }

    return `/${resourceType}`;
  };

  return (
    <>
      <Section
        background="none"
        padding="none"
        containerClass={`!pt-0 !px-4 sm:!px-8 !pb-24 ${styles || ''}`}
        contentfulId={contentful_id}
      >
        <div className="flex w-full flex-col justify-between gap-8 lg:flex-row lg:gap-12">
          <Sidebar activeTag={activeTag} tags={tags} resourceType={resourceType} />
          <div className="flex w-full flex-col items-center gap-12 lg:max-w-[800px]">
            <div className="flex w-full flex-col items-center justify-between gap-4 border-b border-gray-300 pb-4 sm:flex-row">
              <div className="flex flex-col gap-3">
                <div className="anchor-element lg:top-[-150px]" id="listing" />
                <p className="text-xl font-semibold text-black">
                  {activeTag
                    ? `Viewing all "${activeTag?.name}" ${postHeading || 'posts'}`
                    : postHeading || 'All Posts'}
                </p>
              </div>
            </div>
            {posts?.length > 0 ? (
              <div className="flex w-full flex-col gap-8 sm:grid sm:grid-cols-2">
                {posts?.map(post => <ResourceCard key={post?.id} {...post} />)}
              </div>
            ) : (
              <div className="flex w-full flex-col">
                <p className="text-center text-xl">No results found</p>
              </div>
            )}
            {totalPages > 1 && (
              <Pagination
                baseUrl={generateUrl()}
                currentPage={currentPageNumber || 1}
                totalPages={totalPages}
                hasNextPage={hasNextPage}
              />
            )}
          </div>
        </div>
      </Section>
    </>
  );
};

export default PostListing;
